/**
 * The work-pipeline routes, mounted through the `routes.extra.ts` seam.
 *
 * Paths are the ones `domain/nav.ts` ALREADY RESERVED (`work`, `work/:workOrderId`)
 * — the nav links to them today, so an unmounted route is a dead link in a
 * shipped menu. Relative, and mounted inside `RequireCountry` + `AppShell`, so
 * `useCountryCode()` is always resolved by the time a screen renders.
 *
 * Both sit under one pathless layout so they share a single `ToastProvider`
 * (`providers.tsx`): a toast raised by an assignment must survive the navigation
 * from the record back to the board.
 */

import type { RouteObject } from 'react-router-dom';

import { WorkBoardPage } from './WorkBoardPage';
import { WorkOrderRecordPage } from './WorkOrderRecordPage';
import { WorkProviders } from './providers';

export const workPipelineRoutes: RouteObject[] = [
  {
    element: <WorkProviders />,
    children: [
      { path: 'work', element: <WorkBoardPage /> },
      { path: 'work/:workOrderId', element: <WorkOrderRecordPage /> },
    ],
  },
];
